var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOfflinebedroom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 20.2857C13 19.0233 14.0233 18 15.2857 18H15.5455C18.5579 18 21 20.4421 21 23.4545V23.4545C21 23.7558 20.7558 24 20.4545 24H13.7826C13.3504 24 13 23.6496 13 23.2174V20.2857Z",
    fill: "#FD800B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 26.3435V26.3332H37.315H12.7589H12.685V16.4739C12.685 15.6599 12.1027 15 11.3845 15H11.3005C10.5823 15 10 15.6599 10 16.4739V32.6498H12.685V29.3762H37.315V32.6498H40V29.3762V26.3529V26.3435Z",
    fill: "#FD800B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39 21.5784C39 20.3925 38.0255 19.4313 36.8236 19.4313L25.1764 18C23.9745 18 23 18.9612 23 20.147V22.4C23 22.9601 23 23.2401 23.109 23.454C23.2049 23.6422 23.3578 23.7951 23.546 23.891C23.7599 24 24.0399 24 24.6 24H37.4C37.9601 24 38.2401 24 38.454 23.891C38.6422 23.7951 38.7951 23.6422 38.891 23.454C39 23.2401 39 22.9601 39 22.4V21.5784Z",
    fill: "#FD800B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfflinebedroom);
export default __webpack_public_path__ + "static/media/offlinebedroom.2167ab28a20de3450173886e568a74cd.svg";
export { ForwardRef as ReactComponent };